// extracted by mini-css-extract-plugin
export default {"container":"iconsDock_container__sv09H","dock1":"iconsDock_dock1__aQXop","dock2":"iconsDock_dock2__T3NG-","icon":"iconsDock_icon__vJ5hE","tooltip":"iconsDock_tooltip__7-K37"};